const HourlyForecast = ({hourlyForecast}) => {
  return ( 
  <div>
    <div className="pt-3 px-4 m-2 mt-6">
      <h1 className="text-center text-3xl md:text-left">
        Hourly Forecast
      </h1>
    </div>
    <div className="flex flex-row m-1 mb-8 mx-6 overflow-auto">
      { hourlyForecast.map((hour, index) =>  
        <div className="p-2 m-2 mt-0 flex-row grow justify-center text-center" key={index}>
          <div>
            <p>{ hour.dateTime.slice(0, -3) }</p>
            <img className='m-2' alt='hail' src={require('./../icons/' + hour.icon + ".png")} style={{marginLeft: "auto", marginRight: "auto"}} width="40px" height="40px"/>
            {hour.temp} °c
          </div>
        </div> 
      )}
    </div>
  </div>
  );
}
 
export default HourlyForecast;